document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.nav-tabs .nav-link');
    tabs.forEach((tab, index) => {
        tab.addEventListener('click', function (e) {
        e.preventDefault();

        tabs.forEach((t) => t.classList.remove('active'));
        document.querySelectorAll('.tab-pane').forEach((pane) => {
            pane.classList.remove('show', 'active');
        });

        this.classList.add('active');
        const targetPane = document.querySelector(this.getAttribute('href'));
        if (targetPane) {
            targetPane.classList.add('show', 'active');
            initSwipixForPane(targetPane, index);
        }
        });
    });

    // Helper: initialize Swipix for a given pane and tab index (guarded to avoid double-init)
    function initSwipixForPane(targetPane, index) {
        const container = targetPane.querySelector('.pix-container');
        if (!container) return;
        if (container.dataset.swipixInit) return; // already initialized

        new Swipix({
            container: `#${targetPane.getAttribute('id')} .pix-container`,
            gap: 20,
            slidesPerView: { 
                default: 2, 
                768: 3, 
                1024: 5 
            },
            nextButton: `.slider-next-${index}`,
            prevButton: `.slider-prev-${index}`,
        }).init();

        container.dataset.swipixInit = '1';
    }

    // Initialize the active tab's slider on page load (or the first tab if none marked active)
    const activeTab = document.querySelector('.nav-tabs .nav-link.active') || tabs[0];
    if (activeTab) {
        const activeIndex = Array.from(tabs).indexOf(activeTab);
        const initialPane = document.querySelector(activeTab.getAttribute('href'));
        if (initialPane) initSwipixForPane(initialPane, activeIndex);
    }

    // Hide arrow buttons on desktop; on mobile hide only when all slides fit in view
    function updateSliderBtnVisibility() {
        const isDesktop = window.innerWidth >= 768;
        document.querySelectorAll('.tab-pane').forEach((pane) => {
            const slider = pane.querySelector('.category-slider');
            const btnWrapper = pane.querySelector('.tabs-slider-btn');
            if (!slider || !btnWrapper) return;
            if (isDesktop) {
                btnWrapper.style.display = 'none';
                return;
            }
            const slideCount = slider.querySelectorAll('.pix-slide').length || slider.children.length;
            btnWrapper.style.display = slideCount <= 2 ? 'none' : '';
        });
    }

    updateSliderBtnVisibility();
    window.addEventListener('resize', updateSliderBtnVisibility, { passive: true });
});